module.exports = "/packs/images/sprites/arrows~60d2bf309a5f9e0ef39ff78934d23c28.png";